import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { RETIREMENT_STATE_PENSION_AGE } from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import type { InspirationStage } from "web_myplann/Inspiration/Types/InspirationTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

const R = Resources.Inspiration.Retirement;

export const useRetirementCapitalStages = (
	context: RetirementContext,
): InspirationStage[] | undefined => {
	const { t } = useResource();

	if (context.bridgeYears === 0) return undefined;

	return [
		{
			label: t(R.stageBridgeLabel, {
				from: context.retirementAge,
				to: RETIREMENT_STATE_PENSION_AGE,
			}),
			note: t(R.stageBridgeNote),
			value: formatInspirationMoney(context.desiredIncome),
		},
		{
			label: t(R.stageStateLabel, { age: RETIREMENT_STATE_PENSION_AGE }),
			note: t(R.stageStateNote, {
				state: formatInspirationMoney(context.statePension),
			}),
			value: formatInspirationMoney(context.gap),
		},
	];
};
